/**
 * Ryan O'Dowd
 * 2018-04-16
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';
import globals from '@utils/globals';

const getStyles = ({fonts, globalScale, colors, windowWidth, safeAreaInsets}) => {
  return {
    container: {
      display: 'flex',
      maxWidth: Math.min(globals.maxInnerWidth, windowWidth),
    },
    headerInner: {
      display: 'flex',
      // @TODO: width: '100%',
      marginTop: safeAreaInsets.top,
    },
    splitRowsWrapper: {
      flexDirection: 'column',
    },
    headerTextWrapper: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: Platform.OS === 'android' ? 'flex-start' : 'center',
      alignItems: 'center',
    },
    headerTextWrapperSplitRows: {
      flex: 0,
      paddingLeft: Platform.OS === 'android' ? globalScale * 8 : 0,
    },
    secondRow: {
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    titleText: {
      display: 'flex',
      fontSize: globalScale * 20,
      fontFamily: fonts.secondaryBold,
      textAlign: Platform.OS === 'android' ? 'left' : 'center', // @TODO: not working on web (works if display if contents but not if flex)
      color: colors.white,
      marginVertical: globalScale * 4,
    },
    leftItems: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    rightItems: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
  };
};

export default getStyles;
